type DateInput = string | null | undefined;

export const normalizeApiDate = (dateValue: DateInput): Date | null => {
    if (!dateValue) {
        return null;
    }

    const parsedDate = new Date(dateValue);

    if (Number.isNaN(parsedDate.getTime())) {
        return null;
    }

    return new Date(parsedDate.getFullYear(), parsedDate.getMonth(), parsedDate.getDate());
};
